// Persona → audience-tag mapping for the T-CAIREM resources page.
// tagNames must match TCAIREMPersonaTag names in the database (seeded by
// the resources.0009_migrate_tcairem_persona_tags migration).
export const PERSONAS = [
    {
        key: 'educator',
        label: "I'm an educator",
        subtitle: 'Looking for learning materials for my curriculum',
        tagNames: ['Educator'],
    },
    {
        key: 'learner',
        label: "I'm a learner",
        subtitle: 'Looking to learn more about coding or AI in medicine',
        tagNames: ['Learner'],
    },
]
